import MuiLink from '@material-ui/core/Link';
import { Link as GastsbyLink } from 'gatsby';
import React from 'react';

type Props = any;

const Link = (props: Props) => <MuiLink component={GastsbyLink} {...props} />; // eslint-disable-line react/jsx-props-no-spreading

export default Link;
